import { format } from 'date-fns';
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from 'firebase/firestore';
import $ from 'jquery';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { v4 } from 'uuid';
import * as Yup from 'yup';

import { useHistory, useParams } from 'react-router-dom';
import { useAuth } from '~/hooks/auth';
import ICartProduct from '~/interfaces/ICartProduct';

import {
  InputContainer,
  SelectContainer,
} from '~/pages/POS/components/OrderConfirm/styles';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';

import { DB, Realtime } from '~/services/firebase';

import { bff } from '~/services/bff';

import 'jquery-mask-plugin/dist/jquery.mask.min';
import { useOrders } from '~/hooks/orders';
import { useToast } from '~/hooks/toast';
import IReport from '~/interfaces/IReport';

type TableClosingModalProps = {
  total: number;
  artisticCouvertTotal?: number;
  table: string;
  products: ICartProduct[];
  onClose: () => void;
  show: boolean;
  waiter_name?: string;
};

type OrderPayment = {
  payment_method_id: string;
  value: number;
  value2?: number;
  value_formatted: string;
};

interface Params {
  id: string;
}

const { REACT_APP_FIREBASE_PROJECT } = process.env;

const TableClosingModal: React.FC<TableClosingModalProps> = ({
  total,
  artisticCouvertTotal = 0,
  table,
  products,
  onClose,
  show,
  waiter_name,
}) => {
  const { user, company } = useAuth();
  const { addToast } = useToast();
  const { loadOrdersTable } = useOrders();

  const history = useHistory();
  const params = useParams<Params>();
  const { id } = params;

  const [orderPayments, setOrderPayments] = useState<OrderPayment[]>([]);
  const [loading, setLoading] = useState(false);

  const addCardValue = useMemo(() => {
    let sum = 0;
    let isPaymentCreditCard = false;
    let isPaymentDebitCard = false;

    orderPayments.forEach(item => {
      if (item.payment_method_id === '2') {
        // credito
        if (company.add_card && company.add_card > 0) {
          if (company.add_card_type === '1') {
            const addCard = (item.value * company.add_card) / 100;
            sum += addCard;
          } else {
            isPaymentCreditCard = true;
          }
        }
      }

      // debito
      if (item.payment_method_id === '1') {
        if (company.add_card2_type === '1') {
          const addCard = (item.value * company.add_card2) / 100;
          sum += addCard;
        } else {
          isPaymentDebitCard = true;
        }
      }
    });

    if (isPaymentCreditCard) sum += company.add_card;
    if (isPaymentDebitCard) sum += company.add_card2;

    return sum;
  }, [company, orderPayments]);

  const totalValue = useMemo(() => {
    return Number(total) + addCardValue;
  }, [total, addCardValue]);

  const removeOrderPayment = useCallback(
    (index: number) => {
      const tmp = [...orderPayments];
      tmp.splice(index, 1);
      setOrderPayments(tmp);
    },
    [orderPayments],
  );

  const addNewPaymentMethod = useCallback(() => {
    let sum = 0;

    orderPayments.forEach(item => {
      sum += item.value;
    });

    // O total já inclui o couvert artístico
    const remaining = total - sum;

    setOrderPayments(value => [
      ...value,
      {
        payment_method_id: '',
        value: remaining,
        value_formatted: getCurrencyFormatted(remaining),
      },
    ]);

    setTimeout(() => {
      ($('.money') as any).mask('#.##0,00', { reverse: true });
    }, 100);
  }, [orderPayments, total]);

  useEffect(() => {
    // O total já inclui o couvert artístico quando passado do componente pai
    // Garantir que sempre use o total completo quando o modal abrir
    if (show) {
      // O total já inclui o couvert artístico (totalWithCouvert)
      // Sempre inicializar com o total completo
      const finalTotal = total || 0;
      if (finalTotal > 0) {
        setOrderPayments([
          {
            payment_method_id: '',
            value: finalTotal,
            value_formatted: getCurrencyFormatted(finalTotal),
          },
        ]);
      }
    }
  }, [show, total]);

  useEffect(() => {
    ($('.money') as any).mask('#.##0,00', { reverse: true });
  }, [orderPayments]);

  const notify = useCallback(
    (name: string, orderTotal: number, order_id: string, order?: null) => {
      const notification = {
        type: '0',
        description: `Novo pedido criado, no valor de ${getCurrencyFormatted(
          orderTotal,
        )}`,
        link: `/orders/details/${order_id}`,
        company_id: company.uid,
        user_id: company.user_id,
        created_at: new Date(),
        order,
      };

      const notificationsRef = Realtime.ref(`notifications/${company.user_id}`);
      const newNotificationRef = notificationsRef.push();
      newNotificationRef.set(notification);
    },
    [company],
  );

  const orderStatusRealtime = useCallback(
    (order_id: string) => {
      const orderStatus = {
        order_id,
        status: '0',
      };

      const ref = Realtime.ref(`orders/${user.uid}`);
      const newNotificationRef = ref.push();
      newNotificationRef.set(orderStatus);
    },
    [user],
  );

  const updateReport = useCallback(async () => {
    const companiesRef = collection(DB, 'reports');
    const q = query(companiesRef, where('company_id', '==', company.uid));
    const querySnapshot = await getDocs(q);

    const yearMonth = format(new Date(), 'yyyy-MM');
    const day = format(new Date(), 'dd');

    if (!querySnapshot.empty) {
      const item = {
        ...querySnapshot.docs[0].data(),
        uid: querySnapshot.docs[0].id,
      } as IReport;

      let orders_quantity = 1;
      let sales_total = 0;

      if (item.data[yearMonth] && item.data[yearMonth][day]) {
        orders_quantity += item.data[yearMonth][day].orders_quantity;
        sales_total += item.data[yearMonth][day].sales_total;
      }

      await updateDoc(doc(DB, 'reports', item.uid), {
        [`data.${yearMonth}.${day}`]: {
          orders_quantity,
          sales_total,
        },
      });
    }
  }, [company]);

  const handleSubmit = useCallback(async () => {
    setLoading(true);

    console.log('total', total);
    console.log('artisticCouvertTotal', artisticCouvertTotal);

    const uid = v4();
    const code = `${uid.substr(0, 3)}${uid.substr(uid.length - 3, 3)}`;

    const subtotal = Number(total) - Number(artisticCouvertTotal);

    const parseData: any = {
      table: {
        uid: id,
        name: table,
        company_id: company.uid,
        user_id: company.user_id,
      },
      products,
      client_id: '',
      shippingCost: 0,
      subtotal,
      total: Number(total),
      address: {},
      company_id: company.uid,
      company_name: company.fantasy,
      company_user_id: company.user_id,
      created_at: new Date(),
      code,
      status: '0',
      pix_file: '',
      order_type: '0',
      name: `Mesa ${table}`,
      whatsapp: 'não informado',
      orderPayments: orderPayments.map(item => ({
        ...item,
        value: item.value2 ? item.value2 : item.value,
      })),
      paymentMethod: '',
      thing: '',
      uid,
      waiter_name,
      artisticCouvertTotal,
    };

    const schema = Yup.object().shape({
      name: Yup.string().required('O campo nome é obrigatório'),
      whatsapp: Yup.string().required('O campo whatsapp é obrigatório'),
      // paymentMethod: Yup.string().required(
      //   'O campo forma de pagamento é obrigatório',
      // ),
    });

    await schema.validate(parseData, {
      abortEarly: false,
    });

    await setDoc(doc(DB, 'orders', uid), parseData);
    await bff.patch(`/tables-orders/${REACT_APP_FIREBASE_PROJECT}/${id}`);
    await bff.delete(`/orders/${REACT_APP_FIREBASE_PROJECT}`);
    await loadOrdersTable();

    notify(parseData.name, parseData.total, uid, parseData);
    orderStatusRealtime(uid);
    updateReport();

    addToast({
      type: 'success',
      description: `A conta da mesa ${table} foi fechada com sucesso!`,
    });

    setLoading(false);
    onClose();

    history.goBack();
  }, [
    history,
    products,
    company,
    orderPayments,
    table,
    total,
    addToast,
    notify,
    orderStatusRealtime,
    updateReport,
    loadOrdersTable,
    id,
    onClose,
    waiter_name,
  ]);

  return (
    <div className="news-modal" style={{ display: show ? 'block' : 'none' }}>
      <div
        className="modal fade"
        tabIndex={-1}
        id="modalDefault"
        style={{ display: 'block', opacity: 1 }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {`Fechar Conta Mesa ${table || ''}`}
              </h5>
              <div role="button" className="close" onClick={onClose}>
                <em className="icon ni ni-cross" />
              </div>
            </div>
            <div className="modal-body">
              <div className="d-flex justify-content-between">
                <h5>Subtotal</h5>
                <h5>{getCurrencyFormatted(total - artisticCouvertTotal)}</h5>
              </div>
              {artisticCouvertTotal > 0 && (
                <div className="d-flex justify-content-between">
                  <h5>Couvert Artístico</h5>
                  <h5>{getCurrencyFormatted(artisticCouvertTotal)}</h5>
                </div>
              )}
              {addCardValue > 0 && (
                <div className="d-flex justify-content-between">
                  <h5 className="text-danger">Acréscimo Cartão</h5>
                  <h5 className="text-danger">
                    {getCurrencyFormatted(addCardValue)}
                  </h5>
                </div>
              )}
              <h6 className="mt-4">Informe a forma de pagamento</h6>
              <div className="d-flex">
                <div className="w-100">Valor</div>
                <div className="w-100">Forma de pagamento</div>
                <div style={{ width: 80 }} />
              </div>
              {orderPayments.map((paymentItem, index) => (
                <div
                  key={`payment-row-${paymentItem.value}-${index}`}
                  className="d-flex align-items-start"
                >
                  <div className="w-100">
                    <InputContainer>
                      <input
                        key={`input-${paymentItem.value}-${index}-${show}`}
                        id={`payment-value-${index}`}
                        type="text"
                        className="money"
                        placeholder="R$ 0,00"
                        defaultValue={paymentItem.value_formatted}
                        onKeyUp={() => {
                          const { value } = document.getElementById(
                            `payment-value-${index}`,
                          ) as any;

                          let parseValue = '0';

                          if (value) {
                            parseValue = value.replaceAll('.', '');
                            parseValue = parseValue.replaceAll(',', '.');
                          }

                          const tmp = [...orderPayments];
                          tmp[index].value = parseFloat(parseValue);
                          tmp[index].value_formatted = getCurrencyFormatted(
                            parseFloat(parseValue),
                          );

                          setOrderPayments(tmp);
                        }}
                      />
                    </InputContainer>
                  </div>
                  <div className="w-100 ml-2 mr-2">
                    <SelectContainer className="w-100">
                      <select
                        id="payment"
                        defaultValue={orderPayments[index].payment_method_id}
                        onChange={event => {
                          const paymentType = event.target.value;

                          const { value } = document.getElementById(
                            `payment-value-${index}`,
                          ) as any;

                          let parseValue = '0';

                          if (value) {
                            parseValue = value.replaceAll('.', '');
                            parseValue = parseValue.replaceAll(',', '.');
                          }

                          let addValueCardItem = 0;
                          const valueRef = parseFloat(parseValue);

                          if (
                            paymentType === '2' &&
                            company.add_card_type === '1'
                          ) {
                            const addCard = (valueRef * company.add_card) / 100;
                            addValueCardItem += addCard;
                          }

                          if (
                            paymentType === '2' &&
                            company.add_card_type !== '1' &&
                            company.add_card > 0
                          ) {
                            addValueCardItem += company.add_card;
                          }

                          const tmp = [...orderPayments];
                          tmp[index].payment_method_id = event.target.value;

                          tmp[index].value2 = valueRef + addValueCardItem;

                          tmp[index].value_formatted = getCurrencyFormatted(
                            valueRef + addValueCardItem,
                          );

                          setOrderPayments(tmp);
                        }}
                      >
                        <option value="">Selecione...</option>
                        <option value="0">Dinheiro</option>
                        <option value="1">Débito</option>
                        <option value="2">Crédito</option>
                        <option value="3">PIX</option>
                        {company.sell_on_credit === '1' && (
                          <option value="4">Fiado</option>
                        )}
                        <option value="5">IFood</option>
                      </select>
                    </SelectContainer>
                  </div>

                  {index === 0 && (
                    <button
                      type="button"
                      onClick={addNewPaymentMethod}
                      style={{ width: 80, height: 40 }}
                    >
                      <em className="icon ni ni-plus" />
                    </button>
                  )}

                  {index > 0 && (
                    <button
                      type="button"
                      onClick={() => removeOrderPayment(index)}
                      style={{ width: 80, height: 40 }}
                    >
                      <i className="fa fa-trash" />
                    </button>
                  )}
                </div>
              ))}

              <button
                type="button"
                onClick={handleSubmit}
                className="btn btn-primary mt-3 w-100 d-flex justify-content-center items-align-center p-2"
              >
                {loading && (
                  <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden" />
                    </div>
                  </div>
                )}
                {!loading &&
                  `Fechar Conta ${totalValue.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}`}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableClosingModal;
